export default "__VITE_ASSET__BW5pp8tq__"